import React from "react";
import { NavigationBarButton } from "@merge-api/merge-javascript-shared";

interface Props {
  stepTitle: string;
  icon?: JSX.Element;
  lightIndicator?: JSX.Element;
  isSelected: boolean;
  onClick: () => void;
}

const DashboardOnboardingSteps = ({
  stepTitle,
  icon,
  lightIndicator,
  isSelected,
  onClick,
}: Props) => (
  <NavigationBarButton
    selected={isSelected}
    onClick={onClick}
    leftIcon={icon}
    rightIcon={lightIndicator}
    className="border border-gray-10 whitespace-nowrap"
  >
    {stepTitle}
  </NavigationBarButton>
);

export default DashboardOnboardingSteps;
